export default __webpack_public_path__ + "static/media/how-to-play-full.94d43d8c.mp3";